var apiConfig = {
    "exdays": 30,
    "based_url": "https://acms-survey.tranzend.com.ph/api/v1/",
    "api_key": "uTWN3mBQZ2g7d6S5cgY6s3eqRIib4nkDGpsXtECnwC3F89EelhuODs5rg5ZK2guv",
}

module.exports = apiConfig;
